<template>
  <div>
    <SellHeader :img_header="header_image" header="คำสั่งซื้อใหม่" link_back="sell/orderothermain"/>
    <Create_order_other/>
  </div>
</template>

<script>
import SellHeader from "@/components/admin/sell/header_sell/SellHeader";
import HeaderImage from "@/assets/add_item.png";
import Create_order_other from "@/components/admin/sell/Create_order_other";
export default {
  name: "CreateOrderOther",
  components: {
    Create_order_other,
    SellHeader,
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
